import React, { useEffect, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { isEqual } from 'lodash';
import update from 'immutability-helper';
import { Provider } from 'react-redux';
import { compose } from 'redux';

import store from '../../../../../../../store';
import { OfferList } from '../../../../../../../pages/Offers';
import StorePresenter from '../../../../../../../presenters/StorePresenter';
import { orderOffersRestHooks } from '../../../../../../../store/Stores/OrderOffersSlice';

const Offers = (props) => {
  const { brand, upcomingTab, expiredTab, displayedOffers } = props;
  const [offers, setOffers] = useState(displayedOffers);
  const navigate = useHistory();
  const handleRedirectToOffersPage = () => {
    navigate.push(`/brands/${StorePresenter.id(brand)}/offers/new`);
  };
  const isActive = navigate.location.pathname.includes('/offers-tab')
    ? false
    : true;
  const offersOrderUnchanged = isEqual(offers, displayedOffers);

  const { updateOrderOffer } = orderOffersRestHooks.use();

  useEffect(() => {
    setOffers(displayedOffers);
  }, [displayedOffers]);

  const moveRow = (dragIndex, hoverIndex) => {
    const dragOffer = offers[dragIndex];

    setOffers(
      update(offers, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragOffer],
        ],
      })
    );
  };

  const handleClick = async () => {
    const ids = offers.map((offer) => offer.id);
    await updateOrderOffer({ ids });
    window.location.reload();
  };

  return (
    <div className="brand-field">
      <div className="offers">
        <h4>Offers</h4>
        <div className="form-header">
          <div className="tabs">
            <NavLink
              to={`/brands/${StorePresenter.id(brand)}`}
              exact
              activeClassName="active"
            >
              Active
            </NavLink>
            <NavLink
              to={`/brands/${StorePresenter.id(
                brand
              )}/offers-tab/${upcomingTab}`}
              activeClassName="active"
            >
              Upcoming
            </NavLink>
            <NavLink
              to={`/brands/${StorePresenter.id(
                brand
              )}/offers-tab/${expiredTab}`}
              activeClassName="active"
            >
              Expired
            </NavLink>
          </div>
          <div className="form-header-actions">
            {isActive && (
              <button
                disabled={offersOrderUnchanged}
                onClick={handleClick}
                className="button"
              >
                Update Order
              </button>
            )}
            <button
              className="button -add-button"
              onClick={handleRedirectToOffersPage}
            >
              Add Offer
            </button>
          </div>
        </div>
        <OfferList
          offers={offers}
          hideBrand
          isActive={isActive}
          moveRow={moveRow}
        />
      </div>
    </div>
  );
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(Offers);
